(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rise-complete-set"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__riseSetBound) return;
    window.__riseSetBound = true;

    function rate() {
      var r = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate);
      return r > 0 ? r : 1;
    }

    function fmt(cents, cur) {
      var v = cents / 100;
      var whole = Math.abs(v - Math.round(v)) < 0.005;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency', currency: cur,
          minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2
        }).format(v);
      } catch (e) { return cur + ' ' + v.toFixed(2); }
    }

    // Other currencies: convert the AUD saving the same way checkout does.
    function localise(wrap) {
      if (wrap.dataset.currency === wrap.dataset.shopCurrency) return;
      var cur = wrap.dataset.currency;
      var saving = Math.round(parseFloat(wrap.dataset.savingAud || '0') * rate() * 100);
      if (!saving) return;
      var amt = wrap.querySelector('[data-saving-amount]');
      if (amt) amt.textContent = fmt(saving, cur);
      wrap.querySelectorAll('.rise-set__panel[data-eligible="true"]').forEach(function (panel) {
        var price = parseInt(panel.dataset.price, 10) || 0;
        var now = panel.querySelector('[data-price-now]');
        var was = panel.querySelector('[data-price-was]');
        if (now) now.textContent = fmt(Math.max(0, price - saving), cur);
        if (was) { was.textContent = fmt(price, cur); was.hidden = false; }
      });
    }

    function init() {
      document.querySelectorAll('[data-rise-set]').forEach(localise);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();

    document.addEventListener('click', function (e) {
      var chip = e.target.closest('.rise-set__chip');
      if (chip) {
        var w = chip.closest('[data-rise-set]');
        w.querySelectorAll('.rise-set__chip').forEach(function (b) {
          b.setAttribute('aria-checked', b === chip ? 'true' : 'false');
        });
        w.querySelectorAll('.rise-set__panel').forEach(function (p) {
          p.hidden = p.dataset.colour !== chip.dataset.colour;
        });
        return;
      }

      var size = e.target.closest('.rise-set__size');
      if (size && !size.disabled) {
        var panel = size.closest('.rise-set__panel');
        panel.querySelectorAll('.rise-set__size').forEach(function (b) {
          b.setAttribute('aria-checked', b === size ? 'true' : 'false');
        });
        var add = panel.querySelector('[data-rise-set-add]');
        add.dataset.variantId = size.dataset.variantId;
        add.textContent = add.dataset.label;
        add.disabled = false;
        return;
      }

      var btn = e.target.closest('[data-rise-set-add]');
      if (!btn || btn.disabled) return;
      addToCart(btn);
    });

    async function addToCart(btn) {
      var panel = btn.closest('.rise-set__panel');
      var err = panel.querySelector('[data-rise-set-error]');
      var id = btn.dataset.variantId;
      if (!id) return;

      btn.disabled = true;
      err.hidden = true;

      var Ev = null;
      var deferred = null;
      try {
        var mod = await import('@shopify/events');
        Ev = mod.CartLinesUpdateEvent;
        deferred = Ev.createPromise();
        btn.dispatchEvent(new Ev({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(id), quantity: 1 }],
          promise: deferred.promise
        }));
      } catch (x) { Ev = null; }

      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

      try {
        var res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        });
        var data = await res.json();
        if (data && data.status) throw new Error(data.description || data.message || 'Could not add');

        var cart;
        var cic = document.querySelector('cart-items-component');
        if (cic && cic.fetchCartData) {
          cart = await cic.fetchCartData();
        } else {
          cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
        }

        if (Ev && deferred) {
          deferred.resolve({
            cart: Ev.createCartFromAjaxResponse(cart),
            detail: { items: cart.items, source: 'rise-complete-set', sourceId: 'rise-complete-set', itemCount: 1, didError: false }
          });
        } else {
          window.location.href = root + 'cart';
          return;
        }
        document.dispatchEvent(new CustomEvent('rise:cart-changed'));

        btn.textContent = btn.dataset.added;
        setTimeout(function () { btn.textContent = btn.dataset.label; btn.disabled = false; }, 2000);
      } catch (x) {
        if (deferred) deferred.reject(x);
        err.textContent = x.message || 'Could not add — try again';
        err.hidden = false;
        btn.disabled = false;
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
